<div
  class="custom-control custom-radio"
  [ngClass]="{
    'form-check-inline': inline,
    'pmd-radio': theme !== 'bootstrap4',
  }"
>
  <input
    #input
    type="radio"
    class="form-check-input"
    [ngClass]="{
      'filled-in': filledIn || rounded,
    }"
    [id]="id"
    [checked]="state == 'checked'"
    [disabled]="disabled"
    [required]="required"
    [indeterminate]="indeterminate"
    [attr.name]="name"
    [attr.value]="value"
    (click)="onCheckboxClick($event)"
    (change)="onCheckboxChange($event)"
  />
  <label
    class="form-check-label"
    [ngClass]="{
      'pmd-checkbox-ripple-effect': pmdClass,
      'label-before': checkboxPosition === 'right',
      'checkbox-rounded': rounded,
      disabled: disabled,
    }"
    [attr.for]="id"
  >
    <ng-content></ng-content>
  </label>
</div>
